export default function AppEntry() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="relative bg-gradient-to-br from-primary-500 via-primary-600 to-secondary-500 rounded-2xl overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-accent-400/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-background-50/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8 lg:gap-12 p-8 md:p-12 lg:p-16">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4">
                <i className="ri-smartphone-line"></i>
                <span>随时随地</span>
              </div>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50">
                移动观影体验
              </h2>
              <p className="text-sm md:text-base text-background-50/80 mt-4 max-w-md">
                适配手机和平板屏幕，在任何设备上享受流畅高清的观影体验。
                支持横竖屏切换，随时随地追剧看电影，不受场地限制。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6">
                <a
                  href="#media"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector('#media');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full sm:w-auto px-6 py-3 bg-background-50 text-primary-600 font-semibold text-sm rounded-full hover:bg-background-100 transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
                >
                  <i className="ri-android-line mr-2"></i>
                  Android 版本
                </a>
                <a
                  href="#media"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector('#media');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full sm:w-auto px-6 py-3 border-2 border-background-50/40 text-background-50 font-semibold text-sm rounded-full hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
                >
                  <i className="ri-apple-line mr-2"></i>
                  iOS 版本
                </a>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative w-56 h-[380px] md:w-64 md:h-[420px] rounded-3xl overflow-hidden bg-background-800 border-4 border-background-50/20">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20showing%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%2C%20warm%20coral%20and%20golden%20accent%20colors%2C%20modern%20clean%20UI%20design%2C%20dark%20mode%20with%20warm%20highlights%2C%20entertainment%20app%20layout&width=512&height=840&seq=mitao-app-mockup&orientation=portrait"
                  alt="密桃视频移动端界面"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}